module.exports = __webpack_public_path__ + "img/icon2.52f27387.png";